/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_CombinedInputs */

const vi_payment_method_combined = /** @type {(inputs: Payment_Method_CombinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán kết hợp`)
};

/**

* @param {Payment_Method_CombinedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_method_combined = /** @type {((inputs?: Payment_Method_CombinedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_CombinedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_method_combined(inputs)
});